package com.daytimegaming.ourdailyfinances.presentation.account

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.daytimegaming.ourdailyfinances.domain.Response
import com.daytimegaming.ourdailyfinances.domain.model.RealEstateHolding
import com.daytimegaming.ourdailyfinances.domain.repository.AuthRepository
import com.daytimegaming.ourdailyfinances.domain.usecase.RealEstateUseCase
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.launch

sealed class ViewRealEstateHoldingScreenState {
    data object Loading : ViewRealEstateHoldingScreenState()
    data class Error(val message: String) : ViewRealEstateHoldingScreenState()
    data class Loaded(
        val holding: RealEstateHolding,
        val isOwner: Boolean
    ) : ViewRealEstateHoldingScreenState()
}

class ViewRealEstateHoldingViewModel(
    private val realEstateHoldingId: String,
    private val realEstateUseCase: RealEstateUseCase,
    private val authRepository: AuthRepository
) : ViewModel() {

    private val _state = MutableStateFlow<ViewRealEstateHoldingScreenState>(ViewRealEstateHoldingScreenState.Loading)
    val state = _state.asStateFlow()

    init {
        load()
    }

    fun load() {
        viewModelScope.launch {
            combine(
                realEstateUseCase.GetRealEstateHolding(realEstateHoldingId),
                authRepository.currentUser()
            ) { holdingResponse, user ->
                when (holdingResponse) {
                    is Response.Loading -> ViewRealEstateHoldingScreenState.Loading
                    is Response.Error -> ViewRealEstateHoldingScreenState.Error(holdingResponse.message)
                    is Response.Success -> {
                        val holding = holdingResponse.data
                        val isOwner = user?.uid != null && (holding.userId == user.uid || holding.addedByUserId == user.uid)
                        ViewRealEstateHoldingScreenState.Loaded(holding, isOwner)
                    }
                }
            }.collect { nextState ->
                _state.value = nextState
            }
        }
    }
}
